<template>
  <div :class="themeA===1?'white':'black'" class="home"  @click="ClosePop">
    <header2></header2>
    <middle1></middle1>
    <middle2></middle2>
  </div>
</template>

<script setup>
import header2 from '@/layout/header.vue'
import middle1 from '@/layout/middle1.vue'
import middle2 from '@/layout/middle2.vue'
import {computed, ref} from 'vue'
import { useStore} from 'vuex'
import bus from '@/utils/bus';
import { GetSysinfo,GetTabgrade } from '@/api'


const store = useStore()

const themeA = computed(()=>{
  store.state.app.theme===1?document.body.style.background='#fff':document.body.style.background='#131313'
  return store.state.app.theme
})

const ClosePop = ()=>{
  bus.emit('ClosePop');
} 


</script>

<style lang="scss" scoped>
.home{
  // background: var(--bac-ground);
  // width: 100vw;
  // height: 100rem;
  display: flex;
  flex-direction: column;
}
</style>